import { RESERVATION_PLATFORMS, SOCIAL_PLATFORMS } from "./constants"

export const getSocialPlatformDataByLink = (link: string) => {
  if (!link) return
  const normalizedLink = link.toLowerCase()
  const matchedPlatform = SOCIAL_PLATFORMS.find(({ keywords }) => {
    const isMatched =
      keywords.findIndex((keyword) => normalizedLink.includes(keyword)) >= 0
    return isMatched
  })
  return matchedPlatform
}

export const getReservationAppDataByLink = (link: string) => {
  if (!link) return
  const normalizedLink = link.toLowerCase()

  const matchedPlatform = RESERVATION_PLATFORMS.find(({ keywords }) => {
    const isMatched =
      keywords.findIndex((keyword) => normalizedLink.includes(keyword)) >= 0
    return isMatched
  })
  return matchedPlatform
}
